import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Error from "./cmp/Error";
import App from "./App";
import Home from "./view/Home";
import NertzPortal from "./view/nertz/NertzPortal";
import Nertz from "./view/Nertz";
import { RecoilRoot } from "recoil";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <RecoilRoot>
        <App />
      </RecoilRoot>
    ),
    errorElement: <Error />,
    children: [
      {
        index: true,
        element: (
          <RecoilRoot>
            <Home />
          </RecoilRoot>
        ),
        errorElement: <Error />,
      },
      {
        path: "nertz",
        element: (
          <RecoilRoot>
            <NertzPortal />
          </RecoilRoot>
        ),
        errorElement: <Error />,
      },
      {
        path: "nertz/:id",
        element: (
          <RecoilRoot>
            <Nertz />
          </RecoilRoot>
        ),
        errorElement: <Error />,
      },
    ],
  },
]);

function Routes() {
  return <RouterProvider router={router} />;
}

export default Routes;
